// Firebase Storage service for file uploads
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
  listAll,
} from 'firebase/storage';
import { storage } from './firebase';

export const storageService = {
  // Upload a file with progress tracking
  uploadFile: (file, path, onProgress) => {
    return new Promise((resolve, reject) => {
      const storageRef = ref(storage, `bizops/${path}/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        'state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          if (onProgress) {
            onProgress(progress);
          }
        },
        (error) => {
          reject(error);
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve({
            url: downloadURL,
            name: file.name,
            path: `bizops/${path}/${file.name}`,
          });
        }
      );
    });
  },

  // Get download URL for a file
  getFileURL: async (path) => {
    const storageRef = ref(storage, path);
    return await getDownloadURL(storageRef);
  },

  // Delete a file
  deleteFile: async (path) => {
    const storageRef = ref(storage, path);
    await deleteObject(storageRef);
  },

  // List all files in a directory
  listFiles: async (path) => {
    const storageRef = ref(storage, `bizops/${path}`);
    const result = await listAll(storageRef);
    const files = await Promise.all(
      result.items.map(async (item) => ({
        name: item.name,
        path: item.fullPath,
        url: await getDownloadURL(item),
      }))
    );
    return files;
  },
};

export default storageService;
